import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import { DispatchType } from "@/store/app.config";
import Top from "../entrypoint/search/views/All.vue";

const routes = [
    {
        path: "/",
        name: "Top",
        component: Top,
        meta: {
            page: "Top",
            dpname: "DP101",
            title: "ホーム",
        },
    },
    {
        path: "/news",
        //path: "/top/news",
        name: "News",
        component: () => import("../entrypoint/top/views/News.vue"),
        meta: {
            page: "News",
            dpname: "DP002",
            title: "お知らせ一覧",
            breadcrumb: true,
        },
        children: [
            {
                path: ":id(\\d+)",
                name: "NewsDetail",
                component: () =>
                    import("../entrypoint/top/views/news/NewsDetail.vue"),
                meta: {
                    page: "NewsDetail",
                    dpname: "DP003",
                    title: "お知らせ",
                    breadcrumb: true,
                },
            },
        ],
    },
    /* 検索画面 */
    {
        path: "/search/article/paper",
        name: "Paper",
        component: () =>
            import("../entrypoint/search/views/articles/Paper.vue"),
        meta: {
            page: "Paper",
            dpname: "DP201",
            title: "論文",
        },
    },
    {
        path: "/search/article/journal",
        name: "Journal",
        component: () =>
            import("../entrypoint/search/views/articles/Journal.vue"),
        meta: {
            page: "Journal",
            dpname: "DP211",
            title: "掲載誌から探す",
        },
    },
    {
        path: "/search/image/hinshu",
        name: "Hinshu",
        component: () => import("../entrypoint/top/views/NotFound.vue"),
        meta: {
            page: "NotFound",
            dpname: "DP301",
            title: "ページが見つかりません",
        },
    },
    {
        path: "/search/image/noukigu",
        name: "Noukigu",
        component: () =>
            import("../entrypoint/search/views/images/Noukigu.vue"),
        meta: {
            page: "Noukigu",
            dpname: "DP401",
            title: "農機具",
        },
    },
    {
        path: "/search/image/noukigu/searchdetail",
        name: "NoukiguPhoto_1",
        component: () =>
            import("../entrypoint/search/views/images/NoukiguPhoto_major.vue"),
        meta: {
            page: "NoukiguPhoto_1",
            dpname: "DP411",
            title: "農機具",
        },
    },
    {
        path: "/search/image/noukigu/searchdetail/:noukigu_major",
        name: "NoukiguPhoto_2",
        component: () =>
            import("../entrypoint/search/views/images/NoukiguPhoto_middle.vue"),
        meta: {
            page: "NoukiguPhoto_2",
            dpname: "DP412",
            title: "農機具",
        },
    },
    {
        path: "/search/image/noukigu/searchdetail/:noukigu_major/:noukigu_middle",
        name: "NoukiguPhoto_3",
        component: () =>
            import("../entrypoint/search/views/images/NoukiguPhoto.vue"),
        meta: {
            page: "NoukiguPhoto_3",
            dpname: "DP413",
            title: "農機具",
        },
    },
    {
        path: "/search/image/noukigu/searchdetail/:noukigu_major/:noukigu_middle/page/:page",
        name: "NoukiguPhoto_4",
        component: () =>
            import("../entrypoint/search/views/images/NoukiguPhoto.vue"),
        meta: {
            page: "NoukiguPhoto_4",
            dpname: "DP413_Page",
            title: "農機具",
        },
    },
    /* 詳細結果画面（パーマリンク） */
    {
        path: "/RN/:id(20\\d{8})",
        //path: "/rn/RN/:id(20\\d{8})",
        name: "PaperMetadata",
        component: () => import("../entrypoint/rn/views/RN/PaperMetadata.vue"),
        meta: {
            page: "Permalink",
            dpname: "DP203",
            title: "タイトル",
        },
    },
    {
        path: "/browse/journal/searchdetail/:pid(\\d{0,3})/:id(\\w{10})",
        //path: "/rn/browse/journal/searchdetail/:pid(\\d{0,3})/:id(\\w{10})",
        name: "VolumeList",
        component: () =>
            import(
                "../entrypoint/rn/views/browse/journal/searchdetail/JournalVolume.vue"
            ),
        meta: {
            page: "Permalink",
            dpname: "DP213",
            title: "タイトル",
        },
    },
    {
        path: "/browse/journal/searchdetail//:id(\\w{10})",
        //path: "/rn/browse/journal/searchdetail//:id(\\w{10})",
        name: "VolumeList_All",
        component: () =>
            import(
                "../entrypoint/rn/views/browse/journal/searchdetail/JournalVolume.vue"
            ),
        meta: {
            page: "Permalink",
            dpname: "DP213_2",
            title: "タイトル",
        },
    },
    {
        path: "/browse/journal/searchdetail/:pid(\\d{0,3})/:id(\\w{10})/:volume",
        //path: "/rn/browse/journal/searchdetail/:pid(\\d{0,3})/:id(\\w{10})/:volume",
        name: "PaperList_Volume",
        component: () =>
            import(
                "../entrypoint/rn/views/browse/journal/searchdetail/JournalPaper.vue"
            ),
        meta: {
            page: "Permalink",
            dpname: "DP214_1",
            title: "タイトル",
        },
    },
    {
        path: "/browse/journal/searchdetail//:id(\\w{10})/:volume",
        //path: "/rn/browse/journal/searchdetail//:id(\\w{10})/:volume",
        name: "PaperList_Volume_All",
        component: () =>
            import(
                "../entrypoint/rn/views/browse/journal/searchdetail/JournalPaper.vue"
            ),
        meta: {
            page: "Permalink",
            dpname: "DP214_2",
            title: "タイトル",
        },
    },
    {
        path: "/browse/journal/searchdetail/:pid(\\d{0,3})/:id(\\w{10})/:volume/:issue",
        //path: "/rn/browse/journal/searchdetail/:pid(\\d{0,3})/:id(\\w{10})/:volume/:issue",
        name: "PaperList_Issue",
        component: () =>
            import(
                "../entrypoint/rn/views/browse/journal/searchdetail/JournalPaper.vue"
            ),
        meta: {
            page: "Permalink",
            dpname: "DP214_3",
            title: "タイトル",
        },
    },
    {
        path: "/browse/journal/searchdetail//:id(\\w{10})/:volume/:issue",
        //path: "/rn/browse/journal/searchdetail//:id(\\w{10})/:volume/:issue",
        name: "PaperList_Issue_All",
        component: () =>
            import(
                "../entrypoint/rn/views/browse/journal/searchdetail/JournalPaper.vue"
            ),
        meta: {
            page: "Permalink",
            dpname: "DP214_4",
            title: "タイトル",
        },
    },
    {
        path: "/browse/journal",
        // path: "/rn/browse/journal",
        name: "JournalRedirect",
        component: () =>
            import(
                "../entrypoint/rn/views/browse/journal/searchdetail/JournalRedirect.vue"
            ),
        meta: {
            page: "Permalink",
            dpname: "DP213_0",
            title: "タイトル",
        },
    },
    {
        path: "/RN/:id(401\\d{7})",
        //path: "/rn/RN/:id(401\\d{7})",
        name: "HinshuMetadata",
        component: () => import("../entrypoint/rn/views/RN/HinshuMetadata.vue"),
        meta: {
            page: "Permalink",
            dpname: "DP303",
            title: "タイトル",
        },
    },
    {
        path: "/RN/:id(402\\d{7})",
        //path: "/rn/RN/:id(402\\d{7})",
        name: "NoukiguMetadata",
        component: () =>
            import("../entrypoint/rn/views/RN/NoukiguMetadata.vue"),
        meta: {
            page: "Permalink",
            dpname: "DP403",
            title: "タイトル",
        },
    },
    {
        path: "/:id(.*?)",
        name: "NotFound",
        component: () => import("../entrypoint/top/views/NotFound.vue"),
        meta: {
            page: "NotFound",
            dpname: "DP999",
            title: "タイトル",
        },
    },
];

export const menuRoutes = routes.slice(1, routes.length - 1);

const router = createRouter({
    history: createWebHistory("/"),
    routes,
    scrollBehavior(to) {
        //現在ページのセット
        store.dispatch(DispatchType.SET_PAGE, to.name);
    },
});

export default router;
